import * as React from 'react';

// Utils
import { useTranslation } from '@shopee-user/platform';

// Components
import { AccessibleSpan } from '@shopee-user/shared-customization-ui';

// Constants
import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';

// Types
import { SignupTermsOfServiceProps } from '@shopee-user/business-customization-types';

import styles from './style.scss';

export default function SignupTermsOfService({
  onTermsOfServiceClick,
  onPrivacyPolicyClick,
}: SignupTermsOfServiceProps) {
  const I18n = useTranslation();

  const renderDefault = () => {
    return I18n.tNode('msg_auth_signup_agree_to_terms_and_privacy_policy', {
      terms_of_service: (
        <AccessibleSpan
          className={styles.link}
          role="link"
          onClick={event => onTermsOfServiceClick(event)}
        >
          {I18n.t('msg_auth_terms_of_service', {
            context: config.BUSINESS_TARGET,
          })}
        </AccessibleSpan>
      ),
      privacy_policy: (
        <AccessibleSpan
          className={styles.link}
          role="link"
          onClick={event => onPrivacyPolicyClick(event)}
        >
          {I18n.t('msg_auth_privacy_policy')}
        </AccessibleSpan>
      ),
    });
  };

  return (
    <label className={styles.signupTermsOfService}>
      {(() => {
        switch (config.LOCALE) {
          case Locale.MY:
            return I18n.tNode('msg_auth_signup_agree_to_terms', {
              terms_of_service: (
                <AccessibleSpan
                  className={styles.link}
                  role="link"
                  onClick={event => onTermsOfServiceClick(event)}
                >
                  {I18n.t('msg_auth_terms_of_service', {
                    context: config.BUSINESS_TARGET,
                  })}
                </AccessibleSpan>
              ),
            });
          case Locale.TH:
            return I18n.tNode(
              'msg_auth_signup_agree_to_terms_and_privacy_policy_v2',
              {
                terms_of_service: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onTermsOfServiceClick(event)}
                  >
                    {I18n.t('msg_auth_spx_food_terms_of_service')}
                  </AccessibleSpan>
                ),
                privacy_policy: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onPrivacyPolicyClick(event)}
                  >
                    {I18n.t('msg_auth_privacy_policy')}
                  </AccessibleSpan>
                ),
              }
            );
          case Locale.ID:
            return I18n.tNode(
              'msg_auth_signup_agree_to_terms_and_privacy_policy',
              {
                terms_of_service: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onTermsOfServiceClick(event)}
                  >
                    {I18n.t('msg_auth_terms_of_service_id', {
                      context: config.BUSINESS_TARGET,
                    })}
                  </AccessibleSpan>
                ),
                privacy_policy: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onPrivacyPolicyClick(event)}
                  >
                    {I18n.t('msg_auth_code_of_conduct')}
                  </AccessibleSpan>
                ),
                context: config.BUSINESS_TARGET,
              }
            );
          case Locale.VN:
            return I18n.tNode(
              'msg_auth_signup_agree_to_terms_and_privacy_policy_v2',
              {
                terms_of_service: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onTermsOfServiceClick(event)}
                  >
                    {I18n.t('msg_auth_terms_of_service_v2__food-driver')}
                  </AccessibleSpan>
                ),
                privacy_policy: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onPrivacyPolicyClick(event)}
                  >
                    {I18n.t('msg_auth_privacy_policy__food-driver')}
                  </AccessibleSpan>
                ),
              }
            );
          case Locale.PH:
            return I18n.tNode(
              'msg_auth_signup_agree_to_terms_and_privacy_policy__ph',
              {
                terms_of_service: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onTermsOfServiceClick(event)}
                  >
                    {I18n.t('msg_auth_terms_of_service')}
                  </AccessibleSpan>
                ),
                privacy_policy: (
                  <AccessibleSpan
                    className={styles.link}
                    role="link"
                    onClick={event => onPrivacyPolicyClick(event)}
                  >
                    {I18n.t('msg_auth_privacy_policy')}
                  </AccessibleSpan>
                ),
              }
            );
          default:
            return renderDefault();
        }
      })()}
    </label>
  );
}
